import { Button, IconButton, Stack, TextField, Typography } from "@mui/material";
import { Trash } from "lucide-react";

export type Link = {
    title: string;
    href: string;
    target: '_self' | '_blank';
}

interface Props {
    label: string;
    value: Link[];
    onChange: (value: Link[]) => void;
}

const EMPTY_VALUE: Link = {
    title: '',
    href: 'https://',
    target: '_self'
}

const LinksField = ({ label, value = [EMPTY_VALUE], onChange }: Props) => {

    const handleChange = (e: any, index: number) => {
        const links = [...value];

        const fieldName = e.target.name;
        const fieldValue = e.target.value;

        const link = {
            ...links[index],
            [fieldName]: fieldValue,
        };

        links.splice(index, 1, link);
        onChange(links);
    }

    const addLink = () => {
        onChange([...value, EMPTY_VALUE]);
    }
   
    const removeLink = (index: number) => {
        const draft = [...value];
        draft.splice(index, 1);
        onChange(draft);
    }

    return (
        <Stack spacing={2}>
            {label ? (
                <Typography variant="h4">{label}</Typography>
            ) : null}

            {value.map((link, index) => (
                <Stack direction="row" alignItems="center" spacing={2} key={`link-${index}`}>
                    <TextField
                        fullWidth
                        name="title"
                        label="Título"
                        value={link.title}
                        size="small"
                        onChange={(e) => handleChange(e, index)}
                    />
                    <TextField
                        fullWidth
                        name="href"
                        label="Enlace"
                        value={link.href}
                        size="small"
                        onChange={(e) => handleChange(e, index)}
                    />
                    <IconButton onClick={() => removeLink(index)}>
                        <Trash/>
                    </IconButton>
                </Stack>
            ))}
            <Button onClick={addLink}>Agregar enlace</Button>
        </Stack>
    )
}

export default LinksField;
